import * as tslib_1 from "tslib";
import { initCalendarMailboxConfiguration } from 'owa-calendar-configuration';
import { trace } from 'owa-trace';
export default function loadCalendarMailboxConfiguration() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var e_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, initCalendarMailboxConfiguration()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    e_1 = _a.sent();
                    trace.warn(e_1.message || 'loadCalendarMailboxConfiguration failed');
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=loadCalendarMailboxConfiguration.js.map